import React, { useState } from 'react'
import Container from '../../layout/container'
import { BenefitsStyle, TabGroup, TabContent, TabContentItem } from './style'

import Img1 from '../../assets/benefits/Landing1.png';
import Img2 from '../../assets/benefits/Landing2.png';
import Img3 from '../../assets/benefits/Landing3.png';
import Img4 from '../../assets/benefits/Landing4.png';

const items = [
  {
    id: 1,
    title: 'Ingresos extra',
    content: {
      title: 'La marca de belleza #1 de Brasil',
      subtitle: 'te está buscando',
      text: 'Nuestros emprendedores OBoticário pueden obtener ganancias hasta del 50% con los descuentos especiales que reciben cada mes. Sé tú el próximo en descubrir la belleza detrás de cada etapa de tu propio negocio.',
      img: Img1
    }
  },
  {
    id: 2,
    title: 'Productos de calidad',
    content: {
      title: 'Trabajamos por la excelencia de',
      subtitle: 'nuestro portafolio',
      text: 'Las líneas de belleza y cuidado son un éxito por sus fórmulas innovadoras, deliciosas fragancias y procesos sostenibles: nuestro perfume Malbec es uno de los más vendidos en el mundo y la línea Nativa Spa vende un producto por segundo.',
      img: Img3
    }
  },
  {
    id: 3,
    title: 'Venta por redes',
    content: {
      title: 'Aprovecha el',
      subtitle: 'mundo digital',
      text: 'Te apoyamos con herramientas para que sepas vender y alcanzar nuevos clientes a través de las redes sociales. ¡Crecerán tus ventas!',
      img: Img4

    }
  },
  {
    id: 4,
    title: 'Cumple propósitos',
    content: {
      title: 'Que la motivación',
      subtitle: 'nunca se acabe',
      text: 'Queremos ser el vehículo para alcanzar tus metas, cuentas con nuestro constante acompañamiento y asesoría para que paso a paso vayas alcanzando tus objetivos.',
      img: Img2
    }
  }
]

export default function Benefits() {
  const [active, setActive] = useState(1);

  return (
    <BenefitsStyle id="beneficios">
      <Container>
        <h2>Nuestros <span>Beneficios</span></h2>

        <TabGroup>
          {items.map(({ id, title }) =>
            <Tab
              key={id}
              title={title}
              isActive={active === id}
              onItemClicked={() => setActive(id)}
            />
          )}
        </TabGroup>
      </Container>

      <TabContent>
        <Container>
          {items.map(({ id, content }) => {
            return active === id ? <Item key={id} content={content} /> : ''
          })}
        </Container>
      </TabContent>
    </BenefitsStyle>
  )
}

const Tab = ({ id, title, isActive = false, onItemClicked = () => console.error('You passed no action to the component') }) => {
  return (
    <div className={isActive ? 'active' : ''} onClick={onItemClicked}>
      {title}
    </div>
  )
}

const Item = ({ id, content }) => {
  return (
    <TabContentItem>
      <div>
        <h3>
          {content.title}
          <span>{content.subtitle}</span>
        </h3>
        <p>
          {content.text}
        </p>
      </div>

      <img src={content.img} alt={content.title} loading="lazy" />
    </TabContentItem>
  )
}